
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_7378_118758)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_7378_118758)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.568 7.5L12 12.309 19.432 7.5H4.568zM4 9.515V17.5h16V9.515l-7.457 4.825-.543.351-.543-.351L4 9.515zM2 6.5a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1v-12z","fill":"#161616","fill-opacity":".72"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7378_118758"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_7378_118758"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    